import { render, staticRenderFns } from "./PopupNotificationComponent.vue?vue&type=template&id=41f8f4f1"
import script from "./PopupNotificationComponent.vue?vue&type=script&lang=js"
export * from "./PopupNotificationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports